'use es6';

import portalStatus from 'EmailData/reducers/portalStatus';
import combineImmutableReducers from 'EmailData/reducers/helpers/combineImmutableReducers';
import suspendedContacts from './suspendedContacts';
export default combineImmutableReducers({
  status: portalStatus,
  suspendedContacts
});